export var config = {
  apiBaseUrl: 'https://partner-dashbaord-ipj-dev-api.harappa.education/api/v1/',
  partnerApiBaseUrl: 'https://partner-dashboard.harappa.education/partner/v2/',
  JW_PLAYER_KEY: 'fQ0Cuc3YwoUsTs4IgUADPi8O148Iim7zyf6DDaXCAKA',
  INTERCOM_CONFIG: 'l3h90j5i',
  INTERCOM_COURSES: ['Analyzing Problems', 'Listening Actively', 'Reading Deeply', 'Building Presence', 'Defining Problems'],
  //latest key for all environment
  GOOGLE_KEY: "882358584520-gtt34tfufbg1e6bn3phn32l8lu18hfjv.apps.googleusercontent.com",

  //Beta Google key
  // GOOGLE_KEY: "471932248945-d76b6st4doth2uue489vqarvv9ko6lg6.apps.googleusercontent.com",
  //dev Google key
  // GOOGLE_KEY: "471932248945-liqqp8a0is1ovpg9rjc73qi01k75u5j7.apps.googleusercontent.com",
  //Local Google key
  //GOOGLE_KEY: "867355885224-ncmui660si49rmbhc5fgu40b098t6aa9.apps.googleusercontent.com",

  LINKEDIN_KEY: "78eukclqdgyuar",
  AUTH_PASSWORD: "Harappa123",
  DEFAULT_ORGANISATION: 'HARAPPA',
  
  skillLevel: ['An Explorer', 'A Pioneer', 'A Practioner', 'An Ambassador'],
  CAMERATAG_API_KEY: 'a-108d5ad0-9585-0137-5fb9-0adeb7a592e0',
  RAZORPAY_KEY: 'rzp_live_qE09j4Kb3LS8BF',
  
  // GOOGLE_RECAPTCHA_SITEKEY: '6Ldg6PIUAAAAAKOanzG2hfDGtcrm5_xK7Bdbo2lK', //local
  GOOGLE_RECAPTCHA_SITEKEY: '6LfGVPIUAAAAAFx0iwWu-j9Sf6e0h-G_3Qjr9B0m', // also added in index.html google script render=key_value
  B2C_ORGANIZATIONS:['HARAPPA','B2C LITE'],
  SAME_TAB_OPEN_ORG: ['AVANTIKA UNIVERSITY']
}

export const coursePrice = {
  total: 999
}